import '../../../sass/alpha-modules/optional/_slick-carousel.scss'

import 'slick-carousel'
import AlphaHelpers from '../../abstracts/classes/alpha-helpers'
import AlphaModule from '../../abstracts/classes/alpha-module'
import jQuery from 'jquery'

export default class SlickCarousel extends AlphaModule {
  getName() {
    return 'slickCarousel'
  }

  getDefaultConfig() {
    const attrName = AlphaHelpers.getAlphaAttributeName('required-modules')

    return {
      viewportChangesTimeout: 50,
      slickSelector: `[${attrName}*="${this.getName()}"]`,
      slickInitializedClass: 'slick-initialized',
      slickConfig: {
        arrows: true,
        autoplay: true,
        centerMode: true,
        centerPadding: 0,
        dots: true,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        touchMove: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 5,
              swipe: false,
              touchMove: false
            }
          }
        ]
      }
    }
  }

  _onLoad() {
    super._onLoad()

    this._loadCarousels()
  }

  _loadCarousels() {
    const config = this.getConfig()
    const carousels = AlphaHelpers.smartQuerySelectorAll(config.slickSelector)
    carousels.forEach((carouselEl) => {
      // get default config or override it with inline one
      let slickConfig = config.slickConfig
      const slickConfigAttrName = AlphaHelpers.getAlphaAttributeName('slick-config')
      const customConfig = AlphaHelpers.getParsedJsonAttribute(carouselEl, slickConfigAttrName)
      if (customConfig) {
        slickConfig = customConfig
      }

      // load carousel only when breakpoint is below unslick threshold (and update its state)
      const unslickAt = carouselEl.getAttribute(AlphaHelpers.getAlphaAttributeName('unslick-at'))
      if (unslickAt) {
        const viewportModule = this._getManager().getModule('viewport')
        if (viewportModule) {
          const viewport = viewportModule.getViewport()
          const maybeInitializeSlick = (viewport) => {
            const shouldInitialize = !viewport.is(unslickAt)
            if (!shouldInitialize && carouselEl.classList.contains(config.slickInitializedClass)) {
              jQuery(carouselEl).slick('unslick')
            } else if (shouldInitialize && !carouselEl.classList.contains(config.slickInitializedClass)) {
              setTimeout(() => jQuery(carouselEl).slick(slickConfig), config.viewportChangesTimeout)
            }
          }

          // initial check
          maybeInitializeSlick(viewport)

          // listen to viewport changes and update carousel accordingly
          this._getManager().addModuleEventListener(viewportModule.getName(), 'changed', (e) => {
            maybeInitializeSlick(e.viewport)
          })
        }
      } else {
        // load carousel anytime
        jQuery(carouselEl).slick(slickConfig)
      }
    })
  }
}
